export function getAlertBgClass(role: string): string {
  switch (role) {
    case "question":
      return "bg-yellow-100";
    case "info":
      return "bg-green-100";
    case "alert":
      return "bg-red-100";
    default:
      return "bg-gray-100";
  }
}
